<template>
<div class="chapter">
<div class="inner_page">
<p class="pt"><strong><a href="#/Brownsville_toc#part-1">I Thought You and Me Were Friends</a></strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brownsville_part-1.vue?307d3f78